import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { reportSearchFrom } from '@/features/accounting-reports/api'
import { CostByNameScreen } from '@/features/accounting-reports/cost-by-name-screen'
import { hasGrant } from '@/lib/me'

type Search = ReturnType<typeof reportSearchFrom> & {
  party_type?: 'customer' | 'supplier' | 'employee'
  party_id?: string
}

export const Route = createFileRoute('/_authenticated/accounting/reports/cost-by-name')({
  validateSearch: (search: Record<string, unknown>): Search => ({
    ...reportSearchFrom(search),
    party_type: ['customer', 'supplier', 'employee'].includes(String(search.party_type))
      ? (search.party_type as Search['party_type'])
      : undefined,
    party_id: typeof search.party_id === 'string' && search.party_id ? search.party_id : undefined,
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_report.view')) {
      throw redirect({ to: '/accounting' })
    }
  },
  component: CostByNameRoute,
})

function CostByNameRoute() {
  const navigate = useNavigate()
  const search = Route.useSearch()
  return (
    <CostByNameScreen
      search={search}
      onSearchChange={(next) =>
        void navigate({ to: '/accounting/reports/cost-by-name', search: next })
      }
    />
  )
}
